export interface Article {
  id: string;
  title: string;
  slug: string;
  categoryId: string;
  categoryName: string;
  excerpt: string;
  content: string;
  coverImage: string;
  author: string;
  publishDate: string;
  readTime: number;
  tags: string[];
  viewCount: number;
  likeCount: number;
}

export const articles: Article[] = [
  {
    id: 'art-1',
    title: '2026年暑期档最值得期待的电影清单：丝瓜视频独家盘点',
    slug: '2026-summer-movie-list',
    categoryId: 'cat-1',
    categoryName: '丝瓜视频',
    excerpt: '暑期档历来是电影市场的黄金时段，各大影片纷纷定档。本文为您盘点2026年暑期最值得期待的十部电影，涵盖动作、喜剧、科幻等多种类型，让您的夏日观影之旅更加精彩纷呈。',
    content: `<h2>暑期档电影市场前瞻</h2><p>每年暑期档都是电影市场的兵家必争之地，2026年也不例外。从目前已知的定档信息来看，今年暑期档的影片类型十分丰富，无论是喜欢动作大片的观众，还是偏好文艺小清新的影迷，都能找到心仪的观影选择。</p><h2>动作科幻类大片抢先看</h2><p>在动作科幻领域，多部好莱坞巨制已确认引进。这些影片以震撼的视觉效果和紧张刺激的剧情著称，非常适合在大银幕上观看。国产科幻片今年也有亮眼表现，制作水准显著提升。</p><h2>喜剧与爱情片温暖上映</h2><p>暑期档自然少不了轻松愉快的喜剧和浪漫爱情片。今年有多部口碑不错的国产喜剧定档暑期，演员阵容强大，笑点密集，适合全家观看。爱情片方面，几部青春校园题材也值得关注。</p><h2>动画电影精彩纷呈</h2><p>暑期档是动画电影的传统主场，今年国产动画和进口动画都将带来精彩作品。其中多部续集作品备受期待，前作的优秀表现让观众对新作充满信心。</p><h2>观影小贴士</h2><p>暑期档影片密集上映，建议影迷朋友们提前规划观影时间，关注各大平台的预售信息。丝瓜视频将持续为您带来最新的影视资讯和观影指南，敬请关注。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Cinema%20movie%20theater%20interior%20with%20summer%20blockbuster%20posters%2C%20warm%20cinematic%20lighting%2C%20popcorn%20and%20film%20reel%20elements%2C%20modern%20entertainment%20venue%2C%20professional%20movie%20industry%20photography&width=800&height=450&seq=art-01&orientation=landscape',
    author: '影视编辑小王',
    publishDate: '2026-07-28',
    readTime: 8,
    tags: ['暑期档', '电影推荐', '观影指南', '2026电影'],
    viewCount: 12580,
    likeCount: 836,
  },
  {
    id: 'art-2',
    title: '蓝莓视频上线4K超清专区：画质升级带来全新观影体验',
    slug: 'blueberry-4k-upgrade',
    categoryId: 'cat-2',
    categoryName: '蓝莓视频',
    excerpt: '蓝莓视频宣布正式上线4K超清专区，全面升级视频画质。新专区涵盖超过500部4K影片资源，配合HDR技术和杜比全景声，为用户打造影院级观影体验。',
    content: `<h2>4K超清专区正式上线</h2><p>蓝莓视频近日宣布，平台4K超清专区已正式上线运营。这是蓝莓视频在视频画质领域的一次重大升级，标志着平台正式迈入超高清时代。新专区首批上线超过500部4K分辨率的影片资源，涵盖电影、纪录片、自然风光等多种类型。</p><h2>HDR技术带来更真实画面</h2><p>除了分辨率提升至4K级别，蓝莓视频还引入了HDR（高动态范围）技术。HDR能够呈现更丰富的色彩层次和明暗细节，让画面更加接近人眼所见的真实世界。搭配支持HDR的显示设备，观影效果将获得质的飞跃。</p><h2>杜比全景声沉浸体验</h2><p>声音方面，蓝莓视频4K专区支持杜比全景声技术。通过精准的声音定位和空间环绕效果，观众仿佛置身于影片场景之中。无论是呼啸而过的赛车声，还是细腻的环境音效，都能得到完美呈现。</p><h2>设备兼容性说明</h2><p>要体验完整的4K超清画质，用户需要具备以下条件：支持4K分辨率的显示设备、稳定的高速网络（建议50Mbps以上）、支持HDR解码的播放终端。蓝莓视频同时提供了智能适配功能，会根据用户的设备和网络状况自动调整画质。</p><h2>未来展望</h2><p>蓝莓视频表示，未来将继续扩充4K内容库，并探索8K超高清视频的可能性。平台将持续投入技术研发，为用户提供更优质的观影体验。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Ultra%20HD%204K%20television%20display%20showing%20vibrant%20nature%20documentary%2C%20living%20room%20modern%20setup%2C%20cinematic%20high%20quality%20visual%20experience%2C%20professional%20product%20photography&width=800&height=450&seq=art-02&orientation=landscape',
    author: '科技记者小李',
    publishDate: '2026-07-25',
    readTime: 6,
    tags: ['4K超清', '画质升级', 'HDR', '观影体验'],
    viewCount: 9876,
    likeCount: 654,
  },
  {
    id: 'art-3',
    title: '糖心视频独家策划：治愈系日剧推荐TOP20',
    slug: 'tangxin-healing-jdrama',
    categoryId: 'cat-3',
    categoryName: '糖心视频',
    excerpt: '在快节奏的都市生活中，一部温暖的治愈系日剧能够抚慰疲惫的心灵。糖心视频精心挑选了20部高分治愈系日剧，从美食到旅行，从友情到爱情，总有一部能触动你的心弦。',
    content: `<h2>什么是治愈系日剧？</h2><p>治愈系日剧是日本电视剧中一个独特的品类，它以温暖舒缓的叙事节奏、细腻真实的情感表达、以及充满人文关怀的主题而受到观众的喜爱。这类剧集通常没有激烈的戏剧冲突，而是通过日常生活的点滴细节，传递出对生活的热爱和对美好的追求。</p><h2>美食治愈类推荐</h2><p>以美食为主题的治愈系日剧是最受欢迎的子类型之一。剧中精致的料理画面配合温暖的人物故事，既能满足视觉享受，又能触动内心柔软的部分。《深夜食堂》《孤独的美食家》等经典作品至今仍被反复提及。</p><h2>旅行治愈类推荐</h2><p>旅行题材的日剧通过美丽的自然风光和独特的地域文化，带领观众踏上一段心灵之旅。这类剧集往往节奏缓慢，画面唯美，非常适合在闲暇时光慢慢品味。</p><h2>生活治愈类推荐</h2><p>关注普通人生活的治愈系日剧，通过对日常生活的细腻刻画，让观众在平凡中发现不平凡。邻里之间的温情、家人之间的羁绊、朋友之间的默契，都是这类作品的核心主题。</p><h2>观看建议</h2><p>建议在安静舒适的环境中观看治愈系日剧，泡一杯热茶，放下手机，全身心投入到剧情中。糖心视频平台已上线多部高分治愈系日剧，并持续更新片库，欢迎观看。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Cozy%20Japanese%20style%20room%20with%20warm%20lighting%2C%20tea%20and%20books%20on%20wooden%20table%2C%20soft%20natural%20light%20through%20window%2C%20peaceful%20healing%20atmosphere%2C%20minimalist%20lifestyle%20photography&width=800&height=450&seq=art-03&orientation=landscape',
    author: '日剧达人阿美',
    publishDate: '2026-07-22',
    readTime: 10,
    tags: ['治愈系', '日剧推荐', '暖心', '糖心精选'],
    viewCount: 15632,
    likeCount: 1203,
  },
  {
    id: 'art-4',
    title: '黑桃视频深度解析：2026年最烧脑的十部悬疑电影',
    slug: 'heitao-mystery-movies-2026',
    categoryId: 'cat-4',
    categoryName: '黑桃视频',
    excerpt: '悬疑电影的魅力在于层层递进的谜题和出人意料的结局。黑桃视频为您盘点2026年最值得观看的十部悬疑推理电影，每部都能让您的大脑高速运转，体验解谜的快感。',
    content: `<h2>悬疑电影的魅力所在</h2><p>悬疑电影是一种独特的电影类型，它通过精心设计的剧情结构、巧妙的伏笔铺垫和出人意料的结局反转，为观众带来智力上的挑战和情感上的震撼。一部优秀的悬疑电影能够让观众在观影过程中始终保持高度专注，不放过任何一个细节。</p><h2>2026年度悬疑电影榜单</h2><p>今年全球电影市场涌现了多部高质量的悬疑作品，从心理惊悚到犯罪推理，从密室逃脱到时间循环，题材丰富多样。本榜单综合了豆瓣评分、IMDb评分和专业影评人推荐，为您精选出十部不容错过的悬疑佳作。</p><h2>国产悬疑崛起</h2><p>值得关注的是，国产悬疑电影在2026年表现抢眼。多部作品在叙事手法和制作水准上达到了国际一流水准，不仅在国内获得了良好的口碑和票房，也在国际电影节上获得了认可。</p><h2>观影注意事项</h2><p>观看悬疑电影时，建议尽量避免提前了解剧情，保持新鲜感。同时，悬疑电影往往包含一些紧张刺激的场景，请根据自身情况选择合适的观影时段。黑桃视频将持续为您推荐优质悬疑内容，敬请关注。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Mysterious%20dimly%20lit%20detective%20office%20with%20clues%20on%20corkboard%2C%20noir%20atmosphere%2C%20crime%20scene%20evidence%2C%20suspenseful%20moody%20lighting%2C%20professional%20cinematic%20photography&width=800&height=450&seq=art-04&orientation=landscape',
    author: '影评人老张',
    publishDate: '2026-07-20',
    readTime: 9,
    tags: ['悬疑电影', '烧脑推荐', '推理', '2026电影'],
    viewCount: 11234,
    likeCount: 897,
  },
  {
    id: 'art-5',
    title: '妖精视频奇幻剧场：2026年最值得追的十部奇幻动漫',
    slug: 'yaojing-fantasy-anime-2026',
    categoryId: 'cat-5',
    categoryName: '妖精视频',
    excerpt: '奇幻动漫以其天马行空的想象力和精美绝伦的画面深受二次元爱好者喜爱。妖精视频盘点2026年最值得追看的十部奇幻类动漫作品，带您进入不可思议的魔法世界。',
    content: `<h2>奇幻动漫的独特魅力</h2><p>奇幻动漫是日本动漫产业中最具想象力的品类之一。它不受现实世界的限制，可以构建出完全不同的世界观和力量体系。从剑与魔法的中世纪风格到未来科技与魔法融合的赛博朋克，奇幻动漫的创作空间无限广阔。</p><h2>2026年奇幻动漫新番亮点</h2><p>今年有多部备受期待的奇幻动漫新作上线，其中不乏轻小说改编和原创动画。这些作品在画面制作、声优阵容和音乐配乐方面都展现出了极高的水准，无论是剧情党还是画面党都能找到自己的心头好。</p><h2>经典续作回归</h2><p>除了新作之外，多部经典奇幻动漫的续作也在2026年回归。这些续作延续了前作的高品质制作，并在剧情上有了更深入的展开，让老粉丝们大呼过瘾。</p><h2>国产奇幻动漫崛起</h2><p>国产奇幻动漫近年来发展迅速，2026年有多部高质量的国创奇幻作品上线。这些作品融入了中国传统文化元素，创造出了独具特色的东方奇幻美学，值得关注。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Fantasy%20anime%20style%20illustration%20with%20magical%20forest%20and%20glowing%20creatures%2C%20vibrant%20colors%2C%20mystical%20atmosphere%2C%20anime%20art%20style%20with%20detailed%20background%2C%20dreamy%20fantasy%20world&width=800&height=450&seq=art-05&orientation=landscape',
    author: '动漫编辑小陈',
    publishDate: '2026-07-18',
    readTime: 7,
    tags: ['奇幻动漫', '新番推荐', '二次元', '国创动漫'],
    viewCount: 14321,
    likeCount: 1102,
  },
  {
    id: 'art-6',
    title: '桃花视频古装剧场：十部值得重温的经典武侠剧',
    slug: 'taohua-classic-wuxia',
    categoryId: 'cat-6',
    categoryName: '桃花视频',
    excerpt: '武侠剧承载着几代人的青春记忆，那些刀光剑影中的侠义精神至今令人向往。桃花视频为您精选十部经典武侠剧，让我们一起重温那个快意恩仇的江湖世界。',
    content: `<h2>武侠剧：中国独有的文化瑰宝</h2><p>武侠文化是中华文明中一道独特的风景线。它以中国传统文化为根基，融合了儒家的仁义、道家的逍遥和佛家的慈悲，构建出一个充满侠义精神的江湖世界。武侠剧作为武侠文化的重要载体，陪伴了几代中国人的成长。</p><h2>金庸武侠剧经典</h2><p>谈及武侠剧，金庸先生的作品是绕不开的经典。从《射雕英雄传》到《天龙八部》，从《神雕侠侣》到《倚天屠龙记》，每一部都是武侠迷心中的不朽传奇。不同年代拍摄的版本各有特色，值得反复品味。</p><h2>古龙武侠剧魅力</h2><p>与金庸的宏大叙事不同，古龙的武侠世界更加写意和诗意。他的作品以独特的对话风格和悬疑的剧情结构著称，塑造了一批极具个性魅力的侠客形象。</p><h2>新生代武侠剧崛起</h2><p>近年来，一批新生代武侠剧以精良的制作和创新的叙事手法获得了观众的认可。这些作品在保留武侠精神内核的同时，融入了现代审美和特效技术，为武侠剧注入了新的活力。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Classical%20Chinese%20martial%20arts%20scene%20with%20ancient%20temple%20and%20bamboo%20forest%2C%20traditional%20warrior%20silhouette%2C%20misty%20mountain%20landscape%2C%20oriental%20ink%20painting%20style%2C%20dramatic%20atmospheric%20lighting&width=800&height=450&seq=art-06&orientation=landscape',
    author: '武侠迷老刘',
    publishDate: '2026-07-15',
    readTime: 8,
    tags: ['武侠剧', '经典重温', '金庸', '古装'],
    viewCount: 18923,
    likeCount: 1456,
  },
  {
    id: 'art-7',
    title: '丝瓜视频观影指南：如何挑选适合全家观看的周末电影',
    slug: 'family-movie-guide',
    categoryId: 'cat-1',
    categoryName: '丝瓜视频',
    excerpt: '周末与家人一起看电影是最温馨的家庭活动之一。但如何挑选一部适合全年龄段观看的电影呢？丝瓜视频为您提供详细的选片指南，让每个周末都充满欢声笑语。',
    content: `<h2>全家观影的重要性</h2><p>在忙碌的现代生活中，全家人围坐在一起看电影的时光显得尤为珍贵。这不仅是一种娱乐方式，更是增进家庭成员感情的有效途径。通过共同观影，家人之间可以分享感受、交流想法，创造美好的共同记忆。</p><h2>按年龄段选片</h2><p>不同年龄段的家庭成员对电影的需求各不相同。对于有小孩的家庭，应优先选择内容健康、主题积极的动画片或家庭喜剧。有青少年的家庭可以考虑励志成长类影片。对于全成年人家庭，选择范围则更加广泛。</p><h2>经典全家欢电影推荐</h2><p>一些经典的全家欢电影经过时间检验，适合反复观看。迪士尼和皮克斯的动画电影是不错的选择，它们往往包含老少皆宜的幽默和温暖人心的主题。国产喜剧电影中也有不少适合全家观看的佳作。</p><h2>观影环境营造</h2><p>一个好的观影环境能够极大提升观影体验。建议提前准备好零食饮料，调暗灯光，将手机调至静音模式。如果条件允许，可以使用投影仪打造家庭影院的氛围。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Family%20gathered%20on%20cozy%20sofa%20watching%20movie%20on%20large%20TV%2C%20warm%20living%20room%20atmosphere%2C%20popcorn%20and%20snacks%2C%20happy%20family%20bonding%20time%2C%20modern%20home%20interior&width=800&height=450&seq=art-07&orientation=landscape',
    author: '家庭影视顾问赵姐',
    publishDate: '2026-07-12',
    readTime: 6,
    tags: ['家庭观影', '周末电影', '亲子', '观影指南'],
    viewCount: 8956,
    likeCount: 534,
  },
  {
    id: 'art-8',
    title: '蓝莓视频年度报告：2026上半年最受欢迎的十部国产剧',
    slug: 'blueberry-top-dramas-2026',
    categoryId: 'cat-2',
    categoryName: '蓝莓视频',
    excerpt: '2026年上半年的国产剧市场精彩纷呈，多部作品凭借精良的制作和扎实的剧情获得了观众的广泛认可。蓝莓视频基于平台播放数据，发布上半年最受欢迎的十部国产剧榜单。',
    content: `<h2>国产剧市场蓬勃发展</h2><p>2026年上半年，国产剧市场继续保持蓬勃发展态势。从古装传奇到现代都市，从悬疑推理到青春校园，不同类型的优质剧集层出不穷。制作水平的整体提升让国产剧在国内外的影响力不断扩大。</p><h2>榜单解读</h2><p>本次榜单综合了蓝莓视频平台的点播量、完播率、用户评分和弹幕互动量等多个维度的数据，力求客观全面地反映观众的喜好。上榜作品涵盖了多种题材类型，展现了国产剧创作的多元化趋势。</p><h2>古装剧持续火爆</h2><p>古装剧依然是国产剧市场的主力军。上半年有多部制作精良的古装剧上线，无论是服化道的考究程度还是演员的表演水准，都达到了新的高度。这些作品不仅在国内获得了极高的人气，在海外市场也受到了热烈追捧。</p><h2>现实主义题材崛起</h2><p>值得关注的是，现实主义题材的国产剧在2026年上半年表现亮眼。这些作品关注当下社会热点，深入刻画普通人的生活状态和情感世界，引发了观众的强烈共鸣和广泛讨论。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20TV%20drama%20production%20set%20with%20professional%20lighting%20equipment%2C%20modern%20film%20studio%2C%20director%20monitor%20and%20cameras%2C%20behind%20the%20scenes%20cinematography%2C%20warm%20professional%20atmosphere&width=800&height=450&seq=art-08&orientation=landscape',
    author: '数据编辑大刘',
    publishDate: '2026-07-10',
    readTime: 7,
    tags: ['国产剧', '年度榜单', '热播剧', '数据分析'],
    viewCount: 10245,
    likeCount: 789,
  },
];

export const getArticleBySlug = (slug: string): Article | undefined => {
  return articles.find((art) => art.slug === slug);
};

export const getArticlesByCategory = (categoryId: string): Article[] => {
  return articles.filter((art) => art.categoryId === categoryId);
};

export const getRecentArticles = (count: number = 6): Article[] => {
  return [...articles].sort((a, b) => b.publishDate.localeCompare(a.publishDate)).slice(0, count);
};

export const getPopularArticles = (count: number = 4): Article[] => {
  return [...articles].sort((a, b) => b.viewCount - a.viewCount).slice(0, count);
};